import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  Cross,
  Button,
  Modal,
  ModalHeader,
  ModalContent,
  ModalDescription,
  Label,
} from '@cashfree-intl/coherent';
import _trim from 'lodash/trim';

// Services
import { addIPs } from 'services/developers';

// Utils
import Regex from 'utils/regex';
import { isIpDisabled } from '../utils';

// Styled
import { BtnContainer } from 'styled/common';
import { LabelWrapper } from '../styled';

const AddIPAddressModal = ({ onClose, onSubmit }) => {
  const [value, setValue] = useState('');
  const [ips, setIps] = useState([]);

  const handleAddIP = async () => {
    const uniqueIPs = Array.from(new Set(ips));

    const body = ips.length ? uniqueIPs : [value];

    const response = await addIPs(body);

    if (!response.error) {
      onSubmit();
    }

    onClose();
  };

  const handleKeyDown = e => {
    // comma
    if (e.keyCode === 188) {
      e.preventDefault();
    }

    // enter, space & comma
    if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 188) {
      const ip = _trim(value);

      if (Regex.ip(ip)) {
        setIps(prev => prev.concat(ip));
        setValue('');
      }
    }
  };

  const handleIPRemove = selectedIP => {
    setIps(prev => prev.filter(ip => ip !== selectedIP));
  };

  return (
    <Modal $maxWidth="440" open>
      <ModalHeader>
        Add IP Address{' '}
        <Cross
          onClick={onClose}
          data-event-name="Form_AddIPAddress_Icon_Close"
        />
      </ModalHeader>
      <ModalContent>
        <ModalDescription>
          <Text color="bodyLight">IP Address</Text>
          <LabelWrapper>
            {ips.map(ip => (
              <Label>
                {ip}
                <Cross
                  size="sm"
                  className="pl-1"
                  onClick={() => handleIPRemove(ip)}
                />
              </Label>
            ))}
            <input
              type="text"
              value={value}
              onKeyDown={handleKeyDown}
              onChange={e => setValue(e.target.value)}
              placeholder="Ex: 000.000.00.000, 111.111.11.111"
            />
          </LabelWrapper>
          <Text variant="b12" color="bodyLight">
            Use comma (&#44;) or press &#34;space bar&#34; key to add multiple
            IPs
          </Text>
          <BtnContainer>
            <Button
              as="a"
              link
              onClick={onClose}
              data-event-name="Form_AddIPAddress_SecondaryButton"
            >
              Cancel
            </Button>
            <Button
              primary
              className="ml-4"
              onClick={handleAddIP}
              disabled={isIpDisabled(ips, value)}
              data-event-name="Form_AddIPAddress_PrimaryButton"
            >
              Add IP Address
            </Button>
          </BtnContainer>
        </ModalDescription>
      </ModalContent>
    </Modal>
  );
};

AddIPAddressModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default AddIPAddressModal;
